export default __webpack_public_path__ + "static/media/subscriptions.6be746f4.svg";